"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DragDrop_vue_1 = __importDefault(require("@becrop/components/Common/DragDrop.vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const Toast_vue_1 = __importDefault(require("../../../Common/Toast.vue"));
const ModalStamp_vue_1 = __importDefault(require("../../../Common/ModalStamp.vue"));
const Loader_vue_1 = __importDefault(require("../../../Toolkit/Common/UI/Loader.vue"));
let UploadFiles = class UploadFiles extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.fileLength = 0;
        this.type = '';
        this.file = '';
        this.modalSendFiles = false;
        this.loader = false;
        this.typeModal = '';
        this.modalRemplace = false;
        this.errorModal = '';
        this.poligonos = [];
        this.name = '';
    }
    setView(value) {
        this.$emit('setView', value);
    }
    // TODO:====>MODAL SEND<=====
    actionModalContinueSend() {
        this.setView('Map');
        this.$emit('setLocation', this.location);
    }
    actionModalCancelSend() {
        this.modalSendFiles = false;
    }
    backdropActionSend() {
        this.modalSendFiles = false;
    }
    openModalSend(value, typeModal, error, poligonos, name) {
        this.modalSendFiles = value;
        this.typeModal = typeModal;
        this.loader = true;
        this.errorModal = error;
        this.poligonos = poligonos;
        this.name = name;
        setTimeout(() => {
            this.loader = false;
        }, 3000);
        this.$emit('config', poligonos, name);
    }
    fileName(value) {
        this.file = value;
    }
    toastActive(value) {
        this.fileLength = value;
    }
    typeToast(type) {
        this.type = type;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], UploadFiles.prototype, "location", void 0);
UploadFiles = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { DragDrop: DragDrop_vue_1.default, Toast: Toast_vue_1.default, ModalStamp: ModalStamp_vue_1.default, Loader: Loader_vue_1.default },
    })
], UploadFiles);
exports.default = UploadFiles;
